module.exports = __webpack_public_path__ + "static/img/Logo3_SmailingTour.776eef3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Logo3_SmailingTour.png
// module id = 309
// module chunks = 2